import type { Owner } from './Owner';


export enum ContactInteractionType {
  PHONE = 'phone',
  VISIO = 'visio',
  PHYSICAL = 'physical',
  PAPER = 'paper',
  MAIL = 'mail',
  PAPER_FOR_CONSENT = 'paper-for-consent',
  MAIL_FOR_CONSENT = 'mail-for-consent',
  MAIL_FOLLOW_UP = 'mail-follow-up',
}

export interface User {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
}

interface BaseInteraction {
  id: number;
  interactionType: ContactInteractionType;
  interactionAt: string | null;
  interactionWith: User;
  meetingAt: string | null;
  meetingWith: User | null;
  comment: string | null;
  owner: Owner;
  createdAt: string;
  updatedAt: string | null;
  result?: string | null;
}

export interface QualityReferenceInteraction extends BaseInteraction {
  interactionType: ContactInteractionType;
  interactionAt: string;
  meetingAt: string | null;
  meetingWith: User | null;
  comment: string | null;
}

export interface SalesManagerInteraction extends BaseInteraction {
  amount?: string | null;
}

export interface RentManagerInteraction extends BaseInteraction {
  clientType: 'professional' | 'individual';
  duration?: string | null;
}

// Base form data for all interaction types
export interface InteractionFormData {
  interactionType: ContactInteractionType;
  interactionAt?: string; // Added to match backend
  meetingAt: string | null;
  meetingWith: number | null;
  meetingWithType?: string | null;
  comment: string | null;
}

// Specific form data for sales manager interactions
export interface SalesManagerInteractionFormData extends InteractionFormData {
  amount?: string | null;
}

// Specific form data for rent manager interactions
export interface RentManagerInteractionFormData extends InteractionFormData {
  clientType: 'professional' | 'individual'; // Required for rent manager
  duration?: string | null;
  amount?: string | null; // Amount can be present
}

export interface LeadInteraction extends BaseInteraction {
  rgpdDocumentSigned: boolean;
  rgpdDocumentUrl?: string | null;
  rgpdProofUrl?: string | null;
  isEstimationDone?: boolean;
  isDossierComplete?: boolean;
  isMandateObtained?: boolean;
  amount?: string | null;
}

export interface LeadFormData extends InteractionFormData {
  interactionAt: string;
  meetingWithType: string;
  signedFile?: string | null;
  signedAt?: string | null;
  professionalActionDone: boolean;
  clientClosed: boolean;
  data?: Record<string, any>;
  comment: string | null;
  amount?: string | null;
} 